import React from 'react'

interface LogoItem {
  name: string
  src: string
  alt: string
}

const LOGOS: LogoItem[] = [
  { name: 'ADAC', src: '/logos/Logo_ADAC.jpg', alt: 'ADAC' },
  { name: 'ÖAMTC', src: '/logos/ömtc.jpg', alt: 'ÖAMTC' },
  { name: 'ARBÖ', src: '/logos/Arbo.jpg', alt: 'ARBÖ' },
  { name: 'Red Bull', src: '/logos/red-bull.png', alt: 'Red Bull' },
  { name: 'Shell', src: '/logos/Shell.png', alt: 'Shell' },
  { name: 'AXA', src: '/logos/salzburgtaxi-AXA.png', alt: 'AXA' },
  { name: 'Swarovski', src: '/logos/swarovski.jpeg', alt: 'Swarovski' },
  { name: 'Palfinger', src: '/logos/Palfinger.png', alt: 'Palfinger' },
  { name: 'Relais & Châteaux Tennerhof', src: '/logos/tennerhof.png', alt: 'Tennerhof Kitzbühel' },
  { name: 'Rauch', src: '/logos/rauch.png', alt: 'Rauch' },
  { name: 'MediaShop', src: '/logos/mediashop.jpeg', alt: 'MediaShop' },
  { name: 'MozArt', src: '/logos/MozArt.png', alt: 'MozArt' },
  { name: 'Multikraft', src: '/logos/Multikraft.png', alt: 'Multikraft' },
  { name: 'EMCO', src: '/logos/emco.jpeg', alt: 'EMCO' },
  { name: 'SPS', src: '/logos/sps.png', alt: 'SPS' },
  { name: 'TAA', src: '/logos/TAA.jpeg', alt: 'TAA' },
  { name: 'Zeus', src: '/logos/Zeus.jpg', alt: 'Zeus' },
  { name: 'Bio', src: '/logos/bio.png', alt: 'Bio' },
  { name: 'Com-Tec', src: '/logos/com-Tec.png', alt: 'Com-Tec' },
  { name: 'Loko', src: '/logos/Loko.png', alt: 'Loko' },
  { name: 'Nastok', src: '/logos/nastok.jpg', alt: 'Nastok' },
  { name: 'Oldstone', src: '/logos/oldstone.jpg', alt: 'Oldstone' },
  { name: 'Thomsons', src: '/logos/thomsons1.jpg', alt: 'Thomsons' },
  { name: 'Van Beelen', src: '/logos/vanbeelen.jpg', alt: 'Van Beelen' },
  { name: 'Van Hoften', src: '/logos/vanhoften.jpg', alt: 'Van Hoften' },
  { name: '4', src: '/logos/4.png', alt: 'Logo 4' },
  { name: 'Partner', src: '/logos/image001.jpg', alt: 'Partner' },
  { name: 'Partner', src: '/logos/image0024081.png', alt: 'Partner' },
]

export default function LogoMarquee() {
  return (
    <section className="relative w-full overflow-hidden border-b border-gray-100 bg-white py-6 sm:py-8">
      <div className="mx-auto max-w-7xl px-4 mb-4 sm:mb-6 text-center">
        <p className="font-host text-[11px] font-semibold uppercase tracking-[0.2em] text-[#7D8799] sm:text-xs">
          Trusted by Leading Organizations, Luxury Hotels & Global Partners
        </p>
      </div>

      <div className="relative w-full overflow-hidden">
        {/* Soft left and right edge gradient masks */}
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-16 sm:w-28 md:w-40 bg-gradient-to-r from-white via-white/80 to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-16 sm:w-28 md:w-40 bg-gradient-to-l from-white via-white/80 to-transparent" />

        {/* Continuous looping marquee track */}
        <div className="flex w-max items-center animate-marquee hover:[animation-play-state:paused]">
          <div className="flex items-center gap-8 sm:gap-12 md:gap-16 px-4 sm:px-6">
            {LOGOS.map((logo, index) => (
              <div
                key={`logo-a-${index}`}
                className="flex h-12 sm:h-14 items-center justify-center shrink-0"
              >
                <img
                  src={logo.src}
                  alt={logo.alt}
                  title={logo.name}
                  loading="lazy"
                  className="max-h-8 sm:max-h-10 md:max-h-11 w-auto max-w-[120px] sm:max-w-[140px] md:max-w-[160px] object-contain mix-blend-multiply opacity-75 grayscale transition-all duration-300 hover:scale-105 hover:opacity-100 hover:grayscale-0"
                />
              </div>
            ))}
          </div>

          <div className="flex items-center gap-8 sm:gap-12 md:gap-16 px-4 sm:px-6" aria-hidden="true">
            {LOGOS.map((logo, index) => (
              <div
                key={`logo-b-${index}`}
                className="flex h-12 sm:h-14 items-center justify-center shrink-0"
              >
                <img
                  src={logo.src}
                  alt={logo.alt}
                  title={logo.name}
                  loading="lazy"
                  className="max-h-8 sm:max-h-10 md:max-h-11 w-auto max-w-[120px] sm:max-w-[140px] md:max-w-[160px] object-contain mix-blend-multiply opacity-75 grayscale transition-all duration-300 hover:scale-105 hover:opacity-100 hover:grayscale-0"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
